<template>
  <div class="wrap-notfonund f-tac">
    <figure class="figure-img">
      <img src="@/assets/images/icon-403.png" width="100%" height="100%">
    </figure>
    <p class="mg-top10 f-fs16">你还没有查看权限，请联系管理员申请~</p>
    <button class="bullshit-return-home blue-bor f-fs14" @click="goBack()">返回登录页</button>
  </div>
</template>

<script>
export default {
  name: 'Page404',
  computed: {
    message() {
      return this.$route.params.message
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        path: '/login'
      })
      // this.$router.back(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.wrap-notfonund{
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 200px);
  justify-content: center;
  & .figure-img{
    width: 400px;
    margin: 30px auto;
  }
  & .bullshit-return-home{
    width: 100px;
    text-align: center;
    height: 35px;
    color: #fff;
    background: linear-gradient(90deg, #5AA6F9, #4F6DFA);
    border: 1px solid #5AA6F9;
    border-radius: 6px;
    margin-top: 20px;
    padding: 5px 0px;
  }
}
</style>
